module.exports = __webpack_public_path__ + "img/pohyndai.c2cb77b1.png";